var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolandFlagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 205.46 143.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M11.65.4h182.16c6.19 0 11.25 5.06 11.25 11.25v119.88c0 6.18-5.06 11.25-11.25 11.25H11.65C5.46 142.78.4 137.71.4 131.53V11.65C.4 5.46 5.46.4 11.65.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dc143c",
    fillRule: "nonzero",
    d: "M.4 71.59h204.66v59.94c0 6.18-5.06 11.25-11.25 11.25H11.65C5.46 142.78.4 137.71.4 131.53V71.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    fillRule: "nonzero",
    d: "M11.65 0h182.16c3.21 0 6.12 1.31 8.23 3.42a11.61 11.61 0 0 1 3.42 8.23v119.88c0 3.2-1.31 6.11-3.42 8.22-2.11 2.11-5.02 3.43-8.23 3.43H11.65c-3.2 0-6.12-1.32-8.23-3.43A11.604 11.604 0 0 1 0 131.53V11.65c0-3.21 1.31-6.12 3.42-8.23C5.53 1.31 8.45 0 11.65 0zm182.16.8H11.65c-2.99 0-5.7 1.22-7.66 3.19A10.793 10.793 0 0 0 .8 11.65v119.88c0 2.98 1.22 5.69 3.19 7.66 1.96 1.97 4.67 3.19 7.66 3.19h182.16c2.99 0 5.7-1.22 7.67-3.19 1.96-1.97 3.18-4.68 3.18-7.66V11.65c0-2.98-1.22-5.7-3.19-7.66A10.776 10.776 0 0 0 193.81.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolandFlagIcon);
export default __webpack_public_path__ + "static/media/poland_flag_icon.8f1f9b3962119702b1fd3b82ab9d8bb5.svg";
export { ForwardRef as ReactComponent };